import React from 'react';
import { Mail, MapPin, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { COUNTRY_MANAGERS, LIFESTYLE } from '../data/mock';
import Reveal from '../components/Reveal';
import { useFlavour } from '../context/FlavourContext';

export default function CountryManagers() {
  const navigate = useNavigate();
  const { flavour } = useFlavour();
  return (
    <div className="pt-24">
      <section className="relative py-16 md:py-20 overflow-hidden">
        <div className="absolute inset-0"><img src={LIFESTYLE.sunset2} alt="" className="w-full h-full object-cover opacity-25" /><div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/70 to-[#050505]" /></div>
        <div className="relative max-w-[1400px] mx-auto px-5 text-center">
          <Reveal>
            <p className="font-cond tracking-[0.3em] text-white/50 mb-3">OUR NETWORK</p>
            <h1 className="font-display text-5xl md:text-8xl">COUNTRY<br /><span className="text-flavour flavour-transition">MANAGERS</span></h1>
            <p className="text-white/60 mt-5 max-w-xl mx-auto">S-MAN is a premium international brand. Meet the people leading S-MAN across Europe and get in touch with your local team.</p>
          </Reveal>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="max-w-[1400px] mx-auto px-5 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {COUNTRY_MANAGERS.map((m, i) => (
            <Reveal key={m.id} delay={(i%4)*80}>
              <div className="rounded-2xl border border-white/10 bg-[#0b0b0b] p-6 h-full hover:border-[#ff2d2d]/50 transition-all group">
                <div className="flex items-center justify-between">
                  <span className="text-4xl">{m.flag}</span>
                  <span className="font-cond tracking-wide text-xs text-white/40 flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {m.city}</span>
                </div>
                <div className="mt-4 flex items-center gap-4">
                  <img src={m.photo} alt={m.name} loading="lazy" className="w-20 h-20 rounded-full object-cover object-top border-2 shrink-0 group-hover:scale-105 transition-transform" style={{ borderColor: flavour.primary }} />
                  <div className="min-w-0">
                    <h3 className="font-display text-2xl leading-tight truncate">{m.name}</h3>
                    <p className="font-cond tracking-wide text-sm mt-1" style={{color:flavour.primary}}>{m.country}</p>
                    <p className="text-xs text-white/40 mt-1">{m.role}</p>
                  </div>
                </div>
                <a href={`mailto:${m.email}`} className="mt-5 inline-flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors border-t border-white/10 pt-4 w-full">
                  <Mail className="w-4 h-4 text-[#ff2d2d]" /> {m.email}
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-16 bg-[#080808] border-t border-white/10">
        <div className="max-w-[900px] mx-auto px-5 text-center">
          <Reveal>
            <h2 className="font-display text-3xl md:text-5xl">WANT TO BRING S-MAN<br /><span className="text-flavour flavour-transition">TO YOUR COUNTRY?</span></h2>
            <p className="text-white/60 mt-4">We're expanding across new markets. If you'd like to become an S-MAN country manager or distributor, get in touch.</p>
            <a href="mailto:partners@the-sman.com" className="mt-6 inline-flex items-center gap-2 px-8 py-4 rounded-lg bg-[#ff2d2d] text-white font-cond tracking-wide text-lg hover:brightness-110 transition-all">BECOME A PARTNER <ArrowRight className="w-5 h-5" /></a>
          </Reveal>
        </div>
      </section>

      <section className="py-16 text-center">
        <button onClick={()=>navigate('/flavours')} className="inline-flex items-center gap-2 px-8 py-4 rounded-lg border border-white/20 font-cond tracking-wide text-lg hover:bg-white/5 transition-all">EXPLORE THE FLAVOURS <ArrowRight className="w-5 h-5" /></button>
      </section>
    </div>
  );
}
